import { getServerData } from 'js/src/libs/server-data';
import { getServiceLevel, hasFeatureEnabled, ServiceLevel } from 'js/src/libs/server-utils';
import type { DAMConfig } from 'js/src/typings/global';

const Flags = {
    canUseStaffControls: (): boolean => {
        return hasFeatureEnabled('staff_controls');
    },
    canSeeDamTab: (): boolean => {
        const damConfigs = getServerData()?.USER?.dam_configs;
        if (!damConfigs) {
            return false;
        }
        return damConfigs.some((damConfig: DAMConfig) => {
            if (damConfig.require_connection && damConfig.is_connected) {
                return true;
            }
            if (!damConfig.require_connection) {
                return true;
            }
            return false;
        });
    },
    canUseToolbox: () => {
        return hasFeatureEnabled('toolbox');
    },
    canUseVideoBriefs: () => {
        return Flags.canUseToolbox() && hasFeatureEnabled('video_briefs');
    },
    chatTabDeveloperToolsEnabled: () => {
        return hasFeatureEnabled('sketch_show_dev_details');
    },
    canUseScreenRecording: () => {
        return getServerData()?.USER?.capabilities?.screen_recording ?? true;
    },
    hideAllVideoCreationOptions: () => {
        return hasFeatureEnabled('hide_all_videos_creation_options');
    },
    canUseImproveMediaAgent: () => {
        return process.env.NODE_ENV !== 'test';
    },
    canUseAgentFamily: () => {
        if (getServiceLevel() === ServiceLevel.HIGH) {
            return Flags.canUseImproveMediaAgent();
        } else {
            return false;
        }
    },
    canUseAnimatedZoom: () => {
        return hasFeatureEnabled('animated_zoom');
    },
    canUseTransitionSFX: () => {
        return hasFeatureEnabled('sound_effects_transition');
    },
    canUseVideoCreationApi: () => {
        return hasFeatureEnabled('video_creation_api');
    },
    canUseCodeo: () => {
        return hasFeatureEnabled('codeo');
    },
    canUseSubagents: () => {
        return hasFeatureEnabled('subagents');
    },
    canUseCodeoBrand: () => {
        return hasFeatureEnabled('codeo_brand');
    },
    canSeeAllTemplates: () => {
        return hasFeatureEnabled('view_all_templates');
    },
    canUseEnhancedAssetTransform: () => {
        return hasFeatureEnabled('enhanced_asset_transform');
    },
    canUseDisclaimerText: () => {
        return hasFeatureEnabled('disclaimer_text');
    },
    canSeeDownloadMenuProductCallCta: () => {
        return hasFeatureEnabled('product_call_cta_download_menu');
    },
};

export default Flags;
